import React, { useEffect, useState } from "react";
import Title from "antd/es/typography/Title";
import { Card, Table, Modal, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { baseURL } from "../store/api/axios";
import { decryptdata, encryptdata } from "../utils/encryptDecrypt";

const BandLMapping = () => {
  const [data, setData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("")
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const [value, setValue] = React.useState('one'); // Track the selected tab
        
  const handleChange = (event, newValue) => {
     setValue(newValue); 
   };   
  const columns = [
    {
      title: "Subscriber ID",
      dataIndex: "userId",
      key: "userId",
    },
    {
      title: "Business Name",
      dataIndex: "userDetails",
      key: "businessName",
      render: (userDetails) => userDetails?.name || "-",
    },
    {
      title: "Company Name",
      dataIndex: "userDetails",
      key: "companyName",
      render: (userDetails) => userDetails?.companyName || "-",
    },
    {
      title: "Business Email",
      dataIndex: "userDetails",
      key: "businessEmail",
      render: (userDetails) => userDetails?.email || "-",
    },
    {
      title: "Business Number",
      dataIndex: "userDetails",
      key: "phoneNumber",
      render: (userDetails) => userDetails?.mobileNo || "-",
    },
    {
      title: "Lead ID",
      dataIndex: "leadId",
      key: "leadId",
    },
  ];

  const handleExpand = (expanded, record) => {
    setExpandedRowKeys((prevKeys) => {
      if (expanded) {
        return [record._id]; // Add the key if expanding
      } else {
        return prevKeys.filter((key) => key !== record._id); // Remove if collapsing
      }
    });
  };
  //Get Overall Leads List
  const getLeads = async () => {
    try {
      const accessToken = localStorage.getItem("accessToken");
      const encrypt = encryptdata(5)
      const res = await axios.get(
        `${baseURL}lead/distributedleadslist/category/${encrypt}`,
        { headers: { Authorization: `${accessToken}` } }
      );
      const decrypt = decryptdata(res.data);
      const data = decrypt?.data?.data?.leads?.map((item, index) => ({
        ...item,
        key: item._id || index.toString(), 
      }));

      setData(data);
    } catch (error) {
      console.error("Error fetching leads:", error);
    }
  };

  useEffect(() => {
    getLeads();
  }, []);

  const filteredData = (data || []).filter((item) =>
    item.leadId?.toString().toLowerCase().includes(searchTerm.toLowerCase())
  );
  

  return (
    <div>
      <Row>
        <Col md={6}>
          <Title level={3}>Business and Lead Map based on the domain</Title>
        </Col>
        <Col md={6} style={{textAlign:'end'}}></Col>
      </Row>

      <Tabs className="mb-4" value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="primary tabs example">
                <Tab value="one" label="Real Estate" />
                <Tab value="two" label="Health Care" />
                <Tab value="three" label="Financial Service" />
                <Tab value="four" label="Manufacturing" />
                <Tab value="five" label="Movers" />
                <Tab value="six" label="E-Commerce" />
            </Tabs>
            {value == 'one' && (
                       <Card
                       extra={
                        <>
                             <Input
                               placeholder="Search lead ID..."
                               value={searchTerm}
                               onChange={(e) => setSearchTerm(e.target.value)}
                               prefix={<SearchOutlined style={{ color: "#888" }} />}
                               style={{ borderRadius: "5px", padding: "8px 12px" }} />
                        </>
                       }
                       style={{ width: "100%" }}>
                       <Table
                          dataSource={filteredData}
                         columns={columns}
                         expandable={{
                           expandedRowRender: (item) => (
                             <>
                               <Row>
                                 <Col md={4}>
                                   <div style={{ display: "grid" }}>
                                     <p style={{ color: "#595959" }}>Lead Details</p>
                                     <span className="mb-2">
                                        lead ID : {item?.leadId || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Registered Date: 
                                       {new Date(item.createdAt).toISOString().slice(0, 10) || "-"}
                                     </span>
                                     {/* <span className="mb-2 d-flex">
                                       Move on Date: {item?.leadData?.movingDate || "-"}
                                     </span> */}
                                   </div>
                                 </Col>
                                 <Col md={4}>
                                   <div style={{ display: "grid" }}>
                                     <span className="mb-2">
                                       Name : {item?.leadData?.name || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Phone Number : {item?.leadData?.phone || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Email ID : {item?.leadData?.email || "-"}
                                     </span>
                                     {/* <span className="mb-2">
                                       Property Size : {item?.leadData?.propertySize || "-"}
                                     </span> */}
                                   </div>
                                 </Col>
                                 {/* <Col md={4}>
                                   <div style={{ display: "grid" }}>
                                     <span className="mb-2">
                                       Moving from: {item?.leadData?.movingFrom || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Moving to : {item?.leadData?.movingTo || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Available time to call: 
                                       {item?.leadData?.timeToCall || "-"}
                                     </span>
                                     <span className="mb-2">
                                       Property Type: {item?.leadData?.propertyType || "-"}
                                     </span>
                                   </div>
                                 </Col> */}
                               </Row>
                             </>
                           ),
                           rowExpandable: (record) => record.name !== "Not Expandable",
                           expandedRowKeys: expandedRowKeys,
                           onExpand: handleExpand,
                         }}
                       />
                     </Card>    
           )}

{value === 'two' && (
        <Box sx={{p:5}}>
            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Health Care Business table is set to start</h3>
        </Box>
      )}
      {value === 'three' && (
        <Box sx={{p:5}}>
          <h3 style={{textAlign:'center', marginTop:'20px'}}>The Financial Service Business table is set to start</h3>
      </Box>
      )}
      {value === 'four' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Manufacturing Business table is set to start</h3>
       </Box>
      )}
      {value === 'five' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Real Estate Business table is set to start</h3>
       </Box>
      )}
      {value === 'six' && (
        <Box sx={{p:5}}>
           <h3 style={{textAlign:'center', marginTop:'20px'}}>The E-Commerce Business table is set to start</h3>
       </Box>
      )} 
    </div>
  );
};

export default BandLMapping;


// import React, { useEffect, useState } from "react";
// import Title from "antd/es/typography/Title";
// import { Card, Table, Modal, Input } from "antd";
// import { SearchOutlined } from "@ant-design/icons";
// import { Link } from "react-router-dom";
// import { Button } from "@mui/material";
// import { Row, Col } from "react-bootstrap";
// import axios from "axios";
// import Tabs from '@mui/material/Tabs';
// import Tab from '@mui/material/Tab';
// import Box from '@mui/material/Box';

// const BandLMapping = () => {
//   const [data, setData] = useState([]);
//   const [searchTerm, setSearchTerm] = useState("")
//   const [expandedRowKeys, setExpandedRowKeys] = useState([]);
//   const [value, setValue] = React.useState('one'); // Track the selected tab
        
//   const handleChange = (event, newValue) => {
//      setValue(newValue); 
//    };   
//   const columns = [
//     {
//       title: "Subscriber ID",
//       dataIndex: "userId",
//       key: "userId",
//     },
//     {
//       title: "Business Name",
//       dataIndex: "userDetails",
//       key: "businessName",
//       render: (userDetails) => userDetails?.name || "-",
//     },
//     {
//       title: "Company Name",
//       dataIndex: "userDetails",
//       key: "companyName",
//       render: (userDetails) => userDetails?.companyName || "-",
//     },
//     {
//       title: "Business Email",
//       dataIndex: "userDetails",
//       key: "businessEmail",
//       render: (userDetails) => userDetails?.email || "-",
//     },
//     {
//       title: "Business Number",
//       dataIndex: "userDetails",
//       key: "phoneNumber",
//       render: (userDetails) => userDetails?.mobileNo || "-",
//     },
//     {
//       title: "Lead ID",
//       dataIndex: "leadId",
//       key: "leadId",
//     },
//   ];

//   const handleExpand = (expanded, record) => {
//     setExpandedRowKeys((prevKeys) => {
//       if (expanded) {
//         return [record._id]; // Add the key if expanding
//       } else {
//         return prevKeys.filter((key) => key !== record._id); // Remove if collapsing
//       }
//     });
//   };
//   //Get Overall Leads List
//   const getLeads = async () => {
//     try {
//       const accessToken = localStorage.getItem("accessToken");
// const encrypt = encryptdata(5)
//       const res = await axios.get(
//         // `${baseURL}lead/distributedleadslist`,
//         `${baseURL}lead/distributedleadslist/category/${encrypt}`,
//         { headers: { Authorization: `${accessToken}` } }
//       );

//       const data = res?.data?.data?.distributedleads?.map((item, index) => ({
//         ...item,
//         key: item._id || index.toString(), 
//       }));

//       setData(data);
//     } catch (error) {
//       console.error("Error fetching leads:", error);
//     }
//   };

//   useEffect(() => {
//     getLeads();
//   }, []);

//   const filteredData = data.filter((item) =>
//     item.leadId?.toString().toLowerCase().includes(searchTerm.toLowerCase())
//   );

//   return (
//     <div>
//       <Row>
//         <Col md={6}>
//           <Title level={3}>Business and Lead Map based on the domain</Title>
//         </Col>
//         <Col md={6} style={{textAlign:'end'}}></Col>
//       </Row>

//       <Tabs className="mb-4" value={value} onChange={handleChange} textColor="primary" indicatorColor="primary" aria-label="primary tabs example">
//                 <Tab value="one" label="Real Estate" />
//                 <Tab value="two" label="Health Care" />
//                 <Tab value="three" label="Financial Service" />
//                 <Tab value="four" label="Manufacturing" />
//                 <Tab value="five" label="Movers" />
//                 <Tab value="six" label="E-Commerce" />
//             </Tabs>
//             {value == 'one' && (
//                        <Card
//                        extra={
//                         <>
//                              <Input
//                                placeholder="Search lead ID..."
//                                value={searchTerm}
//                                onChange={(e) => setSearchTerm(e.target.value)}
//                                prefix={<SearchOutlined style={{ color: "#888" }} />}
//                                style={{ borderRadius: "5px", padding: "8px 12px" }} />
//                         </>
//                        }
//                        style={{ width: "100%" }}>
//                        <Table
//                           dataSource={filteredData}
//                          columns={columns}
//                          expandable={{
//                            expandedRowRender: (item) => (
//                              <>
//                                <Row>
//                                  <Col md={4}>
//                                    <div style={{ display: "grid" }}>
//                                      <p style={{ color: "#595959" }}>Lead Details</p>
//                                      <span className="mb-2">
//                                         lead ID : {item?.leadId || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Registered Date: 
//                                        {new Date(item.createdAt).toISOString().slice(0, 10) || "-"}
//                                      </span>
//                                      {/* <span className="mb-2 d-flex">
//                                        Move on Date: {item?.leadData?.movingDate || "-"}
//                                      </span> */}
//                                    </div>
//                                  </Col>
//                                  <Col md={4}>
//                                    <div style={{ display: "grid" }}>
//                                      <span className="mb-2">
//                                        Name : {item?.leadData?.name || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Phone Number : {item?.leadData?.phone || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Email ID : {item?.leadData?.email || "-"}
//                                      </span>
//                                      {/* <span className="mb-2">
//                                        Property Size : {item?.leadData?.propertySize || "-"}
//                                      </span> */}
//                                    </div>
//                                  </Col>
//                                  {/* <Col md={4}>
//                                    <div style={{ display: "grid" }}>
//                                      <span className="mb-2">
//                                        Moving from: {item?.leadData?.movingFrom || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Moving to : {item?.leadData?.movingTo || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Available time to call: 
//                                        {item?.leadData?.timeToCall || "-"}
//                                      </span>
//                                      <span className="mb-2">
//                                        Property Type: {item?.leadData?.propertyType || "-"}
//                                      </span>
//                                    </div>
//                                  </Col> */}
//                                </Row>
//                              </>
//                            ),
//                            rowExpandable: (record) => record.name !== "Not Expandable",
//                            expandedRowKeys: expandedRowKeys,
//                            onExpand: handleExpand,
//                          }}
//                        />
//                      </Card>    
//            )}

// {value === 'two' && (
//         <Box sx={{p:5}}>
//             <h3 style={{textAlign:'center', marginTop:'20px'}}>The Health Care Business table is set to start</h3>
//         </Box>
//       )}
//       {value === 'three' && (
//         <Box sx={{p:5}}>
//           <h3 style={{textAlign:'center', marginTop:'20px'}}>The Financial Service Business table is set to start</h3>
//       </Box>
//       )}
//       {value === 'four' && (
//         <Box sx={{p:5}}>
//            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Manufacturing Business table is set to start</h3>
//        </Box>
//       )}
//       {value === 'five' && (
//         <Box sx={{p:5}}>
//            <h3 style={{textAlign:'center', marginTop:'20px'}}>The Real Estate Business table is set to start</h3>
//        </Box>
//       )}
//       {value === 'six' && (
//         <Box sx={{p:5}}>
//            <h3 style={{textAlign:'center', marginTop:'20px'}}>The E-Commerce Business table is set to start</h3>
//        </Box>
//       )} 
//     </div>
//   );
// };

// export default BandLMapping;


